import './src/i18n';
import './config/firebase';

import { ThemeProvider, createTheme } from '@rneui/themed';
import RootNavigator from './src/screens/RootNavigator';

import * as serviceWorkerRegistration from './src/serviceWorkerRegistration';

const customTheme = createTheme({
  colors: {
    primary: 'rgb(110, 90, 150)',
    primaryTrans: 'rgba(110, 90, 150, 0.5)',
    secondary: 'rgb(200, 37, 122)',
    secondaryTrans: 'rgba(200, 37, 122, 0.5)',
    grey: 'rgb(160, 160, 160)',
    background: 'rgb(234, 234, 234)',
  },
  components: {
    Text: {
      style: {
        fontSize: 18,
        color: 'black',
      },
      h1Style: {
        fontWeight: 'normal',
        fontSize: 26,
        color: 'rgb(110, 90, 150)',
      },
      h2Style: {
        fontWeight: 'normal',
        fontSize: 22,
        color: 'rgb(110, 90, 150)',
      },
      h3Style: {
        fontWeight: 'normal',
        fontSize: 20,
        color: 'rgb(110, 90, 150)',
      },
      h4Style: {
        fontWeight: 'normal',
        fontSize: 18,
        color: 'rgb(110, 90, 150)',
      },
    },
  },
});

export default function App() {
  return (
    <ThemeProvider theme={customTheme}>
      <RootNavigator />
    </ThemeProvider>
  );
}

serviceWorkerRegistration.register();
